import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ALERT_LEVELS, ALERT_POSITION } from '@belong/types';
import Alert from '../../Alert';
import { TEST_ID } from '../constants';
import { IFeedbackCapture, IFeedbackCaptureStep } from './Steps.types';

const AnimAlert = styled(Alert)`
  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: appear 300ms ease-in;
`;

interface ICompleteStep extends IFeedbackCaptureStep {
  successMessage: IFeedbackCapture['successMessage'];
}

export const CompleteStep: FunctionComponent<ICompleteStep> = ({ successMessage }) => {
  return (
    <AnimAlert
      data-testid={TEST_ID.COMPLETE_STEP}
      id="feedback-alert"
      type={ALERT_LEVELS.SUCCESS}
      position={ALERT_POSITION.INLINE}
    >
      {successMessage}
    </AnimAlert>
  );
};

CompleteStep.displayName = 'CompleteStep';
